import { PowerSettingsIcon } from './PowerSettingsIcon';

/**
 * author: Google
 * id B5587844-E70A-4F55-A2DA-CE85D8F79689
 * name power-settings
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/power-settings.svg
 * tags
 * - Settings 
 */
export const SettingsPowerIcon = PowerSettingsIcon;
export default SettingsPowerIcon